import { render, staticRenderFns } from "./MailingsRecipients.vue?vue&type=template&id=243b144a&scoped=true&"
import script from "./MailingsRecipients.vue?vue&type=script&lang=ts&"
export * from "./MailingsRecipients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243b144a",
  null
  
)

export default component.exports